import { AccountLinkResponseDto, INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import IntegrationsService from "../../../../../services/api/integrations-service";
import { TYPE, rootContainer } from "../../../../../services/container/root";
import { ICredentialsStore } from "../integration-store";

type TrackstarAllowedEndpoints = "get_inventory" | "get_products" | "create_product" | "update_product" | "get_inbound_shipment" | "create_inbound_shipment" | "update_inbound_shipment" | "get_orders" | "create_order" | "update_order" | "create_kit" | "update_kit" | "get_returns" | "create_return" | "update_return" | "get_shipping_methods" | "get_bills" | "get_warehouses" | "get_warehouse_customers" | "get_labor_activities";

type TrackstarClientConfig = {
    getLinkToken: () => Promise<string>;
    onSuccess: (authCode: string, integrationName: string) => void;
    onClose?: () => void;
    onLoad?: () => void;
    integrationAllowList?: string[];
    integrationBlockList?: string[];
    integrationsWithEndpoints?: TrackstarAllowedEndpoints[];
    buttonId?: string;
    sandbox?: boolean;
}

class TrackstarCredentialsStore implements ICredentialsStore {
    private _window = {} as Window;
    private _intervalId: any = undefined;
    private _closeInterval = 50;

    private get integrationsService(): IntegrationsService {
        return rootContainer.get<IntegrationsService>(TYPE.IntegrationsService);
    }

    public async getCredentials(isSandbox = false) {
        return new Promise(async (resolve, reject) => {
            const accountLinkResponse = await this.getAccountLink(reject, isSandbox);

            const trackstarClientConfig: TrackstarClientConfig = {
                getLinkToken: async () => accountLinkResponse!.authLink,
                onSuccess: (code: string) => {
                    this._window.close();
                    resolve({
                        accountLinkResponse,
                        oauthPayload: {
                            code,
                        },
                    });
                },
                sandbox: isSandbox,
            };

            this._window = window.open('', '_blank', 'width=800,height=600') as Window;
            this._window.opener.returnGO = { trackstarClientConfig };
            this._window.document.write(`
                <!doctype html>
                    <html lang="en">
                        <head>
                            <meta charset="utf-8">
                            <meta name="viewport" content="width=device-width, initial-scale=1">                            
                        </head>
                        <body>
                            <div id="root"></div>
                        </body>
                    </html>
            `)
            const scriptElement = this._window.document.createElement('script');
            scriptElement.src = `${process.env.PUBLIC_URL}/trackstar.js`;
            scriptElement.defer = true;
            this._window.document.head.appendChild(scriptElement);

            this._listenToWindowClosed(reject);
        });
    }

    private async getAccountLink(reject: (reason?: any) => void, isSandbox: boolean): Promise<AccountLinkResponseDto | undefined> {
        try {
            return await this.integrationsService.createAccountLink(INTEGRATION_CODE.TRACKSTAR, null, isSandbox);
        }
        catch (err) {
            reject(err);
        }
    }

    private _listenToWindowClosed(reject: (reason?: any) => void) {
        /** make sure to always clear interval before starting new one */
        clearInterval(this._intervalId);

        this._intervalId = setInterval(() => {
            if (!this._window.closed) {
                return;
            }
            clearInterval(this._intervalId);
            reject(new Error('Authorization interrupted, window was closed before finishing the process'));
        }, this._closeInterval);
    }
}

export default TrackstarCredentialsStore;
